export class Subscription {
  constructor(
    public isDefaultLogin: boolean,
    public id: number,
    public pkId: string,
    public fullCompanyName: string,
    public status: string,
    public accessBegins: string,
    public accessEnds: string,
    public applicationId: number,
    public isDeleted: boolean,
    public type: string,
    public registrationType: number
  ) { }
}
